export const MainContent = (props) => (
  <div id="main-content" className="container" {...props}>
    {props.children}
  </div>
);
